import { Grid, IconButton, InputAdornment, Paper, Stack, TextField, Typography } from "@mui/material";
import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import Logo from "../../shared/img/Logo.svg";
import { LogoImg, SingupButton } from "./ExternalLogin";
import { css } from "@emotion/react";
import { PRIMARY_COLOR } from "../../theme";
import { verifyPassword } from "./RegisterPassword";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "../../shared/utils/Constants";
import AuthenticationService from "../../services/AuthenticationService";


const ResetPassword = () => {
    const [pass, setPass] = useState();
    const [confirmPass, setConfirmPass] = useState();
    const [errPass, setErrPass] = useState(false);
    const [errConfirmPass, setErrConfirmPass] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handlePassword = (e) => {
        setPass(e.target.value);
        if (!verifyPassword.test(e.target.value)) {
            setErrPass(true)
        } else {
            setErrPass(false)
        }
    }

    const handleConfirmPassword = (e) => {
        setConfirmPass(e.target.value);
        if (!(pass === e.target.value)) {
            setErrConfirmPass(true)
        } else {
            setErrConfirmPass(false)
        }
    }

    const verifyCanSave = () => {
        if (!errPass && !errConfirmPass && pass && confirmPass && pass === confirmPass) {
            return false
        }
        return true
    }

    async function hashPassword(password) {
        const encoder = new TextEncoder();
        const data = encoder.encode(password);
        const hash = await window.crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hash)); // Converte para um array de números
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Converte números para strings hexadecimais

        return hashHex;
    }

    const sendNewPassword = async () =>{
        setLoad(true);
        const code = searchParams.get('code');
        await hashPassword(pass).then(async hashHex => {
            await AuthenticationService.resetPassword(hashHex, code).finally(() => {
                setTimeout(() => {
                    navigate(routes.exLogIn)
                }, 5000)
            })
        });
    }

    useEffect(()=>{
        async function getCodeConfrimation() {
            const code = searchParams.get('code');
            if (!code) {
                navigate(routes.exLogIn)
            }
        }
        getCodeConfrimation();
    }, [searchParams])

    return (
        <Spin fullscreen spinning={load}>
            <Grid xs={12} container sx={css`height: 100vh;`}>
                <Grid item xs={12} sx={css`display: flex; margin: auto; align-items: center;`}>
                    <Grid item xs={12} container lg={12} className="pl-6 pr-6 pb-12 pt-12">
                        <Grid item xs={12} alignContent={"center"}>
                            <Paper elevation={3} square={false} align="center" sx={css`width: 30%;padding: 20px;margin-left: 35%;`}>
                                <Stack direction={"column"} spacing={3}>
                                    <LogoImg src={Logo} alt="Logo Yara" align="center" />
                                    <div>
                                        <Typography variant="h5" sx={css`color:${PRIMARY_COLOR};font-family: YaraMax;`}>Homologação Digital</Typography>
                                        <Typography variant="h5" sx={css`color:${PRIMARY_COLOR};font-family: YaraMax;`}>Cadastro de nova senha</Typography>
                                    </div>
                                    <TextField
                                        error={errPass}
                                        placeholder="Senha"
                                        onChange={handlePassword}
                                        type={showPassword ? 'text' : 'password'}
                                        helperText={errPass ? 'Senha não está forte o suficiente. Precisa ter 8 characteres, conter pelo menos 1 letra maiuscula, 1 numero e 1 caracter especial.' : ''}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                    />
                                    <TextField
                                        error={errConfirmPass}
                                        placeholder="Confirmar Senha"
                                        onChange={handleConfirmPassword}
                                        type={showPassword ? 'text' : 'password'}
                                        helperText={errConfirmPass ? 'Senhas não coincidem!' : ''}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>

                                        }}
                                    />
                                    <SingupButton disabled={verifyCanSave()} onClick={sendNewPassword}>Salvar</SingupButton>
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Spin>
    )
}

export default ResetPassword;